import { FormContextManager, getFormContext } from "config/FormContext";
import React, { useContext } from "react"
import { DropdownInputPropsType } from "types/form-types";
import { validateInput } from "utilities/input-utilities"
import CoreDropdownInput from "./CoreDropdownInput";

type DropdownInputPropsTypeInternal<T, TFilterType, TSortType> = DropdownInputPropsType<T, TFilterType, TSortType> & {
    formContext: FormContextManager
}

class DropdownInputClass<T, TFilterType, TSortType> extends React.Component<DropdownInputPropsTypeInternal<T, TFilterType, TSortType>> {
    
    private validate = (soft: boolean, input: HTMLInputElement | undefined, inputWrapper: HTMLDivElement | undefined) => {
        const customErrors = [...(this.props.customErrors || [])];
        if (this.props.required) {
            customErrors.push({
                name: 'valueMissing',
                message: 'form.errors.valueMissing',
                validate: i => {
                    return this.props.value ? true : false;
                },
            })
        }

        const errors = validateInput({
            value: this.props.value,
            input,
            inputWrapper,
            customErrors: customErrors,
            soft: soft ? true : false
        });

        return errors || [];
    }
    // #endregion value

    // #region render
    render(): React.ReactNode {
        return (
            <CoreDropdownInput
                {...this.props}
                value={this.props.value}
                validate={this.validate}
            />
        );
    }
    // #endregion render
};

function DropdownInput<T, TFilterType, TSortType>(props: DropdownInputPropsType<T, TFilterType, TSortType>) {
    const formContext = getFormContext(useContext);
    return <DropdownInputClass
        {...props}
        formContext={formContext}
    />
}

export default DropdownInput;
